"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _FormControl = require("../FormControl");
var _tss = require("../styles/tss");
const _excluded = ["classes", "className", "control", "disabled", "label"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsFormControlLabel',
  uniqId: 'RRkri0'
})((theme, _params, classes) => {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      [`&.${classes.disabled}`]: {
        cursor: 'default'
      }
    },
    /* Styles applied to the Label's component. */
    label: {
      [`&.${classes.disabled}`]: {
        color: theme.busbud.colors.component.textfield.disabled.label
      }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {}
  };
});
const getControlProps = props => {
  const {
    control,
    disabled
  } = props;
  const propsToControl = ['checked', 'name', 'onChange', 'value', 'inputRef'];
  const isPropDefined = propName => typeof control.props[propName] === 'undefined' && typeof props[propName] !== 'undefined' ? props[propName] : undefined;
  return propsToControl.reduce((controlProps, currentProp) => {
    const prop = isPropDefined(currentProp);
    if (prop !== undefined) {
      // @ts-ignore
      controlProps[currentProp] = prop;
    }
    return controlProps;
  }, {
    disabled
  });
};

/**
 * **❗️ DEPRECATED**
 *
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 *
 * @deprecated
 */
const FormControlLabel = /*#__PURE__*/React.forwardRef(function FormControlLabel(props, ref) {
  const {
      classes: classesOverrides,
      className,
      control,
      disabled: disabledProp,
      label
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const formControl = (0, _FormControl.useFormControl)();
  const {
    classes,
    cx
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  let disabled = disabledProp;
  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }
  if (typeof disabled === 'undefined' && formControl) {
    disabled = formControl.disabled;
  }
  return /*#__PURE__*/React.createElement("label", (0, _extends2.default)({
    className: cx(classes.root, {
      [classes.disabled]: disabled
    }, className),
    ref: ref
  }, other), /*#__PURE__*/React.cloneElement(control, getControlProps(props)), /*#__PURE__*/React.cloneElement(label, {
    className: cx(classes.label, {
      [classes.disabled]: disabled
    })
  }));
});
var _default = exports.default = FormControlLabel;